module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"pageTitle":"Вход","email":"Электронная почта","password":"Пароль","loginButton":"Войти","forgotPassword":"Забыли пароль?","badLoginOrPassword":"Неправильный адрес или пароль"}}')
  delete Component.options._Ctor
}
